import { GenericFiltrationContract } from "./GenericFiltrationContract";

export class MediaFilterationContract extends GenericFiltrationContract {

    constructor(parentId, pageIndex = 1, pageSize = 10, isStory = false, extraMediaItems = null, isChild = false){
        super(parentId, pageIndex, pageSize);
        this.IsStory = isStory;
        this.ExtraMediaItems = extraMediaItems;
        this.IsChild = isChild;
    }

    IsStory:any;
    IsChild:any;
    ExtraMediaItems: any[];
}